import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { reqPost, reqGet } from '../../../../service';
import settingIcon from '../../../../images/uiw_setting.png';
import Select from 'react-select';
import { formatNumber } from '../../../../utils/formatNumber';

const Property = styled.div`
  position: relative;
  border: 2px solid ${p => p.$selected ? p.theme.borderSelected : p.theme.border};
  padding: 28px 16px 16px;
  margin: 6px;
  border-radius: ${p => p.theme.radius};
  flex: 1 1 calc(33.33% - 12px);
  min-width: 220px;
  max-width: calc(33.33% - 12px);
  background: ${p => p.$selected ? p.theme.bgSelected : p.theme.bgCard};
  transition: ${p => p.theme.transition};
  box-shadow: ${p => p.theme.shadowCard};
  box-sizing: border-box;

  &:hover {
    box-shadow: ${p => p.theme.shadowCardHover};
    border-color: ${p => p.theme.borderSelected};
  }

  @media screen and (min-width: 600px) and (max-width: 1024px) {
    flex: 1 1 calc(50% - 12px);
    max-width: calc(50% - 12px);
  }

  @media screen and (max-width: 600px) {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    margin: 4px 0;
    padding: 24px 12px 12px;
  }
`;

const CardContent = styled.div`
  list-style: none;
  color: ${p => p.theme.text};
  width: 100%;
  cursor: pointer;
  transition: ${p => p.theme.transition};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// 단일 선택은 동그라미, 다중 선택은 체크박스 모양 — 좌상단 배치
const SelectionDot = styled.span`
  position: absolute;
  top: 12px;
  left: 12px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${p => p.theme.accent};
`;

const SelectionCheck = styled.span`
  position: absolute;
  top: 8px;
  left: 8px;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background: ${p => p.theme.accent};
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-bottom: 2px;
  }
`;

const GearButton = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  padding: 0;
  background: ${p => p.theme.bgInput};
  border: 1px solid ${p => p.theme.border};
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: ${p => p.theme.transition};
  z-index: 2;

  img { width: 12px; height: 12px; }

  &:hover {
    background: ${p => p.theme.accentLight};
    border-color: ${p => p.theme.accent};
  }
`;

const NamePriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

const LeftTxt = styled.div`
  text-align: left;
  font-weight: 700;
  font-size: 15px;
  color: ${p => p.theme.text};
  flex: 1;
`;

const RightTxt = styled.div`
  text-align: right;
  font-weight: 700;
  font-size: 13px;
  white-space: nowrap;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 2px;
  color: ${p => p.theme.text};

  span {
    color: ${p => p.theme.textMuted};
    font-size: 11px;
  }
`;

const BottomTxt = styled.div`
  text-align: left;
  font-size: 12px;
  color: ${p => p.theme.textMuted};
  line-height: 1.5;
  min-height: 32px;
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid ${p => p.theme.border};
  margin-top: 4px;
`;

const SelectTag = styled.span`
  font-size: 11px;
  color: ${p => p.theme.textMuted};
  font-weight: 600;
`;

// ===== 편집 모달 =====
const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: ${p => p.theme.bgOverlay};
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalCard = styled.div`
  background: ${p => p.theme.bgCard};
  border: 1px solid ${p => p.theme.border};
  border-radius: ${p => p.theme.radius};
  padding: 22px;
  width: 420px;
  max-width: 92vw;
  box-shadow: ${p => p.theme.shadowLg};
`;

const ModalTitle = styled.h3`
  margin: 0 0 16px;
  font-size: 15px;
  font-weight: 700;
  color: ${p => p.theme.text};
`;

const FormGroup = styled.div`
  margin-bottom: 12px;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
  color: ${p => p.theme.text};
  font-size: 12px;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid ${p => p.theme.borderInput};
  border-radius: ${p => p.theme.radiusSm};
  font-size: 13px;
  box-sizing: border-box;
  background: ${p => p.theme.bgInput};
  color: ${p => p.theme.text};

  &:focus { outline: none; border-color: ${p => p.theme.borderInputFocus}; }
  &:disabled { opacity: 0.6; }
`;

const FormTextArea = styled.textarea`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid ${p => p.theme.borderInput};
  border-radius: ${p => p.theme.radiusSm};
  font-size: 13px;
  min-height: 60px;
  resize: vertical;
  font-family: inherit;
  box-sizing: border-box;
  background: ${p => p.theme.bgInput};
  color: ${p => p.theme.text};
  &:focus { outline: none; border-color: ${p => p.theme.borderInputFocus}; }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid ${p => p.$selected ? p.theme.accent : p.theme.border};
  background: ${p => p.$selected ? p.theme.accentLight : p.theme.bgCard};
  border-radius: ${p => p.theme.radiusSm};
  cursor: pointer;
  font-size: 12px;
  color: ${p => p.theme.text};
  transition: ${p => p.theme.transition};

  input { accent-color: ${p => p.theme.accent}; cursor: pointer; }

  small {
    color: ${p => p.theme.textMuted};
    margin-left: auto;
    font-size: 11px;
  }
`;

const ModalButtons = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
  align-items: center;
`;

const ModalBtn = styled.button`
  padding: 8px 14px;
  border-radius: ${p => p.theme.radiusSm};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: ${p => p.theme.transition};
  border: 1px solid ${p => p.$primary ? 'transparent' : p.$danger ? p.theme.error : p.theme.border};
  background: ${p => p.$primary ? p.theme.accent : p.theme.bgCard};
  color: ${p => p.$primary ? '#fff' : p.$danger ? p.theme.error : p.theme.text};

  &:hover {
    background: ${p => p.$primary ? p.theme.accentHover : p.$danger ? '#fee2e2' : p.theme.bgHover};
  }
`;

export default function CategoryCard(props) {
  const [ItemList, setItemList] = useState([]);
  const [Selected, setSelected] = useState(props.SelectedData);

  useEffect(() => {
    getItemList();
  }, [props.CategoryList]);

  const getItemList = () => {
    reqGet('/api/ItemList', { group_id: props.group_id, category: props.Key }, (res) => { setItemList(res); });
  };

  return (
    <>
      {ItemList.map((item, idx) => (
        <Card key={idx}
          Selected={Selected}
          name={item.item_name}
          price={item.item_price}
          description={item.item_description}
          category={props.Key}
          group_id={item.group_id}
          Type={props.Type}
          onSelected={(e) => {
            setSelected(e.name);
            props.calcValue({
              GROUP: e.group_id,
              Key: e.category,
              NAME: e.name,
              PRICE: Number(e.price),
              DESCRIPTION: e.description,
              NEXT: item.next_category,
            });
          }}
          onAfterEdit={getItemList}
        />
      ))}
    </>
  );
}

function Card(props) {
  const [displayPrice, setDisplayPrice] = useState(props.price);
  const [displayDescription, setDisplayDescription] = useState(props.description || '');
  const [editPrice, setEditPrice] = useState(props.price);
  const [editDescription, setEditDescription] = useState(props.description || '');
  const [editNext, setEditNext] = useState(null);
  const [saveMode, setSaveMode] = useState('once');
  const [bSelect, setbSelect] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [CategorySelect, setCategorySelect] = useState([]);

  useEffect(() => {
    setDisplayPrice(props.price);
    setDisplayDescription(props.description || '');
  }, [props.price, props.description]);

  useEffect(() => {
    if (props.Type === 'S') {
      setbSelect(props.Selected === props.name);
    }
  }, [props.Selected, props.Type, props.name]);

  useEffect(() => {
    reqGet('/api/CategorySelect', { value: props.group_id }, (res) => setCategorySelect(res));
  }, [props.group_id]);

  const openEditModal = (e) => {
    e.stopPropagation();
    setEditPrice(displayPrice);
    setEditDescription(displayDescription);
    setEditNext(null);
    setSaveMode('once');
    setShowModal(true);
  };

  const handleSave = () => {
    if (saveMode === 'permanent') {
      reqPost('/api/UpdatePrice', {
        item_price: editPrice,
        category: props.category,
        item_name: props.name,
        group_id: props.group_id,
        item_description: editDescription,
      }, () => {
        const finishSave = () => {
          alert('영구 저장 완료');
          setDisplayPrice(editPrice);
          setDisplayDescription(editDescription);
          setShowModal(false);
          props.onAfterEdit && props.onAfterEdit();
        };
        if (editNext && editNext.value) {
          reqPost('/api/setNext', {
            next: editNext.value,
            category: props.category,
            item_name: props.name,
          }, finishSave);
        } else {
          finishSave();
        }
      });
    } else {
      setDisplayPrice(editPrice);
      setDisplayDescription(editDescription);
      setShowModal(false);
    }
  };

  const handleDelete = () => {
    if (!window.confirm(`"${props.name}" 항목을 영구 삭제하시겠습니까?`)) return;
    reqPost('/api/DeleteCard', {
      category: props.category,
      item_name: props.name,
      group_id: props.group_id,
    }, () => {
      alert('삭제했습니다.');
      setShowModal(false);
      props.onAfterEdit && props.onAfterEdit();
    });
  };

  const isMulti = props.Type === 'M';

  return (
    <>
      <Property $selected={bSelect}>
        {bSelect && (isMulti ? <SelectionCheck /> : <SelectionDot />)}
        <GearButton onClick={openEditModal} title="편집">
          <img src={settingIcon} alt="설정" />
        </GearButton>
        <CardContent
          onClick={() => {
            props.onSelected({ ...props, price: displayPrice, description: displayDescription });
            if (isMulti) {
              setbSelect(!bSelect);
            } else {
              setbSelect(true);
            }
          }}
        >
          <NamePriceRow>
            <LeftTxt>{props.name}</LeftTxt>
          </NamePriceRow>
          <BottomTxt>{displayDescription}</BottomTxt>
          <CardFooter>
            <SelectTag>{bSelect ? '선택됨' : '선택'}</SelectTag>
            <RightTxt>
              <label>{formatNumber(displayPrice)}</label>
              <span>만원</span>
            </RightTxt>
          </CardFooter>
        </CardContent>
      </Property>

      {showModal && (
        <ModalBackdrop onClick={() => setShowModal(false)}>
          <ModalCard onClick={(e) => e.stopPropagation()}>
            <ModalTitle>항목 편집 — {props.name}</ModalTitle>

            <FormGroup>
              <FormLabel>이름</FormLabel>
              <FormInput value={props.name} disabled />
            </FormGroup>

            <FormGroup>
              <FormLabel>가격 (만원)</FormLabel>
              <FormInput
                type="text"
                value={formatNumber(editPrice)}
                onChange={(e) => {
                  const v = e.target.value.replace(/,/g, '');
                  if (!isNaN(v)) setEditPrice(v);
                }}
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>설명</FormLabel>
              <FormTextArea
                value={editDescription}
                onChange={(e) => setEditDescription(e.target.value)}
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>다음 카테고리</FormLabel>
              <Select
                options={CategorySelect}
                value={editNext}
                placeholder="선택 시 다음에 표시될 카테고리"
                onChange={setEditNext}
                isClearable
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>적용 범위</FormLabel>
              <RadioGroup>
                <RadioOption $selected={saveMode === 'once'}>
                  <input
                    type="radio"
                    name={`saveMode-${props.name}`}
                    checked={saveMode === 'once'}
                    onChange={() => setSaveMode('once')}
                  />
                  <span>이번 견적에만 적용</span>
                  <small>DB 변경 안 함</small>
                </RadioOption>
                <RadioOption $selected={saveMode === 'permanent'}>
                  <input
                    type="radio"
                    name={`saveMode-${props.name}`}
                    checked={saveMode === 'permanent'}
                    onChange={() => setSaveMode('permanent')}
                  />
                  <span>영구 저장</span>
                  <small>모든 견적에 반영</small>
                </RadioOption>
              </RadioGroup>
            </FormGroup>

            <ModalButtons>
              <ModalBtn $danger onClick={handleDelete}>삭제</ModalBtn>
              <div style={{ flex: 1 }} />
              <ModalBtn onClick={() => setShowModal(false)}>취소</ModalBtn>
              <ModalBtn $primary onClick={handleSave}>저장</ModalBtn>
            </ModalButtons>
          </ModalCard>
        </ModalBackdrop>
      )}
    </>
  );
}
